
export const ESCAPE="\\";




export const ARRAY_SEPARATOR=" ";
export const ARRAY_SEPARATOR_NAME="a space";


export const TOKEN_SEPARATOR=".";


export const SPECIAL_CHARS=new Set([ESCAPE,TOKEN_SEPARATOR,ARRAY_SEPARATOR]);


export const escapeSpecialChars=(string)=>
string.replaceAll(SPECIAL_CHARS_REGEXP,`${ESCAPE}$&`);

const SPECIAL_CHARS_REGEXP=/[\\. ]/gu;